import React, { memo, useCallback } from 'react'

import { ExternalLink, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, string } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { detachHistory, setActiveMobilePanel } from 'Pods/ThreeDStudio/Store/actions/ui'
import { MOBILE_PANEL } from 'Pods/ThreeDStudio/Store/constants'

import { getBreakPoint } from 'Utils/useBreakpoint'

const detachIconSize = { height: '20px', width: '20px' }

function Header({ title, canDetach = false, isDetachDisabled = false }) {
  const t = useTranslation()

  const handleDetach = useCallback(() => {
    detachHistory()
    // Between 960px and 1280px the studio shows one panel at a time behind
    // .mobile-tab-bar, so switch to the 3D model tab to keep the viewer beside the window.
    if (getBreakPoint(window.innerWidth) === 'md') {
      setActiveMobilePanel(MOBILE_PANEL.VIEWER)
    }
  }, [])

  if (!canDetach) {
    return <span className="enhance-model-panel__title cgt-heading-50">{title}</span>
  }

  return (
    <div className="variations-tab__header">
      <span className="cgt-heading-50">{title}</span>
      <button
        type="button"
        className="variations-tab__detach"
        aria-label={t('viewerSidebar.enhance.variations.window.detach')}
        disabled={isDetachDisabled}
        onClick={handleDetach}
      >
        <Icon svgComponent={ExternalLink} color="dark" size={detachIconSize} notSpaced />
      </button>
    </div>
  )
}

Header.propTypes = {
  title: string.isRequired,
  canDetach: bool,
  isDetachDisabled: bool,
}

export default memo(Header)
